import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { AdminService } from './admin.service';
import { environment } from '@env/environment';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestOptions, Http, Headers } from '@angular/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { CoreService } from '../core/core.service';
import { Main } from '@app/core/main.service';

@Component({
  selector: 'cp-customer-add',
  templateUrl: './customer.add.component.html',
})

export class CustomerAddComponent {

  customer: any;
  file: any;
  topPart: string;
  bottomPart: string;
  secondContent: string;
  clients: any;
  regions: any;
  formHasError: boolean;
  match: boolean;
  isLoading: boolean;
  id: string;
  user: string;
  filter: string;
  baseUrl: string = environment.production
    ? environment.ONLINE_BASE_URL :
    environment.LOCAL_BASE_URL;
  localUrl: any;
  files_temp: any[];
  uploadResponse = { status: '', message: '', filePath: '' };
  uploading = false;
  successUploadCount = 0;
  failedUploadCount = 0;


  constructor(private api: AdminService, private route: ActivatedRoute, private mainService: Main, private http: Http, private router: Router,
    @Inject(Restangular) public Restangular) {

    this.customer = {
      //user: "",
      id_passport_number: "",
      phone_number_1: "",
      phone_number_2: "",
      email: "",
      gender: "",
      region: "",
      city: "",
      sub_city: "",
      woreda_kebele: "",
      house_no: "",
      emergency_contact: "",
      emergency_phone: ""
    };
    this.filter = '';
    this.regions = [
      { name: "Addis Ababa", value: "Addis Ababa" },
      { name: "Afar", value: "Afar" },
      { name: "Amhara", value: "Amhara" },
      { name: "Benishangul", value: "Benishangul-Gumuz" },
      { name: "Diredawa", value: "Dire Dawa" },
      { name: "Gambela", value: "Gambela" },
      { name: "Harari", value: "Harari" },
      { name: "Oromia", value: "Oromia" },
      { name: "Sidama", value: "Sidama" },
      { name: "Somali", value: "somali" },
      { name: "SNNP", value: "SNNP" },
      { name: "Tigray", value: "Tigray" },
    ];
    this.clients = [];
    this.files_temp = [];
    //padding:20px 200px 20px 200px;
    this.formHasError = false;
    this.match = true;
    this.isLoading = false;

    if (this.route.queryParams['value']['id']) {
      debugger;
      this.id = this.route.queryParams['value']['id'];
      this.getCustomer();
    }
    if (this.route.queryParams['value']['user'] && this.id == null) {
      debugger;
      this.user = this.route.queryParams['value']['user'];
      this.getUserProfile(this.user);
    }
  }

  fileChange(event, type): void {
    debugger;
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
    let fileName: any;
    fileName = this.file['name'];
    if (this.file) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.localUrl = event.target.result;
        this.compress(this.localUrl, fileName, type);
      }
      reader.readAsDataURL(this.file);
    }
  }

  getCustomer() {
    debugger;
    this.api.getProfile(this.id, this.filter).subscribe((res: any) => {
      debugger;
      this.customer = res.data;
      this.user = this.customer.user.data.id;
      //this.customerForm.setValue(res.data);
    });
  }


  getUserProfile(id: string) {
    debugger;
    this.api.getUserProfile(id).subscribe((res: any) => {
      debugger;
      this.customer = res.data;
      this.user = this.customer.user.data.id;
      //this.customerForm.setValue(res.data);
    });
  }


  async compress(image: any, fileName: string, type: string) {
    console.log('compressing...');
    var temp = await this.mainService.compressFile(image, fileName)
    temp[0].designation = type;
    this.files_temp.push(temp);
    debugger;
    console.log(this.files_temp);
  }


  public async uploadFile(id: any) {
    debugger;
    this.successUploadCount = 0;
    this.failedUploadCount = 0;
    for (let file of this.files_temp) {
      console.log(file[0]);
      var designation = file[0].designation;
      const formData = new FormData();
      if (file[0] instanceof File) {
        formData.append('file', file[0], file[0].name);
        formData.append('item_id', id);
        formData.append('designation', designation);
        this.uploading = true;
        await this.mainService.upload(formData).then((res: any) => {
          this.uploadResponse = res;
          console.log(res);
          if (this.uploadResponse.status !== 'progress' &&
            this.uploadResponse.status !== 'unhandeled event') {
            this.successUploadCount++;
            let temp = (this.successUploadCount / this.files_temp.length) * 100;
            this.uploadResponse.message = temp.toString();
          }
        }, function (err) {
          debugger;
          this.failedUploadCount++;
        });
        if (this.successUploadCount > 0) {
          this.mainService.toast({ title: 'Success', body: designation + 'File successfully uploaded! ', type: 'dark' });
        }

      }
    }
  }

  @ViewChild('customerForm', { read: ElementRef }) tref: ElementRef;

  checkFormValidity(): boolean {
    return (this.tref.nativeElement.className.indexOf('ng-invalid') !== -1);
  }

  confirmPassword() {
    this.match = this.customer.password === this.customer.confirm_password;
  }

  addCustomer(id: any = null) {
    debugger;
    this.isLoading = !this.isLoading;
    let isInvalid = this.checkFormValidity();

    if (!isInvalid && this.match) {
      this.customer.user = this.user;
      this.api.addCustomer(id, this.customer).subscribe((res: any) => {
        //this.api.addCustomer(id, { profile: this.customer }).subscribe((res: any) => {
        this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
        this.isLoading = !this.isLoading;
        if (this.files_temp.length > 0) {
          this.uploadFile(this.user);
        } else {
          //this.mainService.addToast('Success', 'Customer successfully added!');
          this.router.navigate(['/customers']);
        }
      }, (err) => {
        err = err;
        this.isLoading = !this.isLoading;
        this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
        //this.mainService.addToast('Error', 'Could not add customer!');
      });
    } else {
      this.isLoading = !this.isLoading;
      this.formHasError = true;
    }

  }

}
